// ======================================================================
// File Name       : usageSettingLive
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import { commonCallApi } from '../../utils/ApiUtils';

export function getLiveReservedList(params) {
  return commonCallApi({
    path: 'live/GetReservedList',
    data: { ...params },
  });
}

export function getLiveReservationTime() {
  return commonCallApi({
    path: 'live/GetReservationTime',
  });
}

export function getEachLiveUserCountList(params) {
  return commonCallApi({
    path: 'live/EachLiveUserCount',
    data: { ...params },
  });
}

export function getUserLiveRelationList(params) {
  return commonCallApi({
    path: 'userLiveRelation/GetList',
    data: { ...params },
  });
}

export function registerEditLiveReservation(params) {
  return commonCallApi({
    path: 'live/EditReserve',
    data: { ...params },
  });
}

export function registerEditLiveUserRelation(params) {
  return commonCallApi({
    path: 'liveUserRelation/Edit',
    data: { ...params },
  });
}

export function getJoinableLiveList(params) {
  return commonCallApi({
    path: 'live/GetJoinableLive',
    data: { ...params },
  });
}

export function getServiceList(searchInfo) {
  return commonCallApi({
    path: 'service/GetList',
    data: searchInfo,
  });
}

export function getUserLiveRecordedFileList(params) {
  return commonCallApi({
    path: 'live/GetRecordedVideo',
    data: { ...params },
  });
}